import * as React from 'react';

import { TestId } from '../constants';
import { ReactComponent as ArrowIcon } from './assets/arrow.svg';
import styles from './styles/Grid.scss';

type IPaginationProps = {
  currentPage: number;
  maxPages?: number;
  onChangePage(page: number): void;
};

const Pagination: React.FC<IPaginationProps> = ({
  currentPage,
  maxPages,
  onChangePage,
}) => {
  const isNextDisabled = maxPages !== undefined && currentPage >= maxPages;
  const isPrevDisabled = currentPage <= 1;
  const handleNextClick = () =>
    !isNextDisabled && onChangePage(currentPage + 1);
  const handlePrevClick = () =>
    !isPrevDisabled && onChangePage(currentPage - 1);
  const currentPageText = currentPage.toLocaleString();
  const maxPageText = maxPages ? maxPages.toLocaleString() : 'more';

  return (
    <div className={styles.pagination} data-testid={TestId.Pagination}>
      <button
        className={styles.prevPage}
        onClick={handlePrevClick}
        disabled={isPrevDisabled}
        aria-label="Previous"
        data-testid={TestId.PagePrev}
      >
        <ArrowIcon />
      </button>
      <div className={styles.pages} data-testid={TestId.PaginationText}>
        {`Page ${currentPageText} of ${maxPageText}`}
      </div>
      <button
        className={styles.nextPage}
        onClick={handleNextClick}
        disabled={isNextDisabled}
        aria-label="Next"
        data-testid={TestId.PageNext}
      >
        <ArrowIcon />
      </button>
    </div>
  );
};

export default Pagination;
